const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/admin/offers/$offerId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { validateAdminOfferDetailSearch } from "@/routes/_app/admin/admin-offer-list-search";
import { adminPageTitle } from "@/routes/_app/admin/admin-page-title";
export const Route = createFileRoute("/_app/admin/offers/$offerId/")({
  head: ({
    params
  }) => ({
    meta: [{
      title: adminPageTitle(`Listing ${params.offerId}`)
    }]
  }),
  validateSearch: validateAdminOfferDetailSearch,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});